angular.module('lsnBase.deprecated.models')
  .factory('ClausesModelConstants', ['LsnClausesModelConstants', function(LsnClausesModelConstants) {
    return LsnClausesModelConstants;
  }])
  .factory('ClausesModel', ['LsnClausesModelV1',
    function(LsnClausesModelV1) {
      return LsnClausesModelV1;
    }
  ]);